export default {"src":"/_next/static/media/Deer.d3aa35fc.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};